// extracted by mini-css-extract-plugin
module.exports = {"avatarImage":"FormRegistartion_avatarImage__1HsCG","loadLogo":"FormRegistartion_loadLogo__3jkk1"};